// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"31b5451c","453":"33c63d34","455":"e6522939","977":"b35ae323"}[chunkId] + ".chunk.js";
};